export default __webpack_public_path__ + "static/media/Press Machine.7c0b123b.jpg";